import DocCompHeader from './DocCompHeader';
import DocAttachment from './docAttachment/DocAttachment';
import DocAttachmentEditor from './docAttachment/DocAttachmentEditor';
import DocAttachmentRow from './docAttachment/DocAttachmentRow';
import DocReferenceAttachmentRow from './docAttachment/DocReferenceAttachmentRow';
import DocImage from './docImage/DocImage';
import DocImageEditor from './docImage/DocImageEditor';
import DocImageRow from './docImage/DocImageRow';
import DocAttribute from './docAttribute/DocAttribute'
import DocAttributeRow from './docAttribute/DocAttributeRow'
import DocFormReview from './docReviewStatus/DocFormReview';
import DocReviewRow from './docReviewStatus/DocReviewRow';
import DocChildActivator from './DocChildActivator';
import ReferenceBreakup from "./ReferenceBreakup";
import ReferenceBreakupRow from "./ReferenceBreakupRow";

import DocLog from "./docComment/DocLog";

import DocLogEditor from "./docComment/DocLogEditor";
import DocLogRow from "./docComment/DocLogRow";

import DocShare from './DocShare';
import DocTag from './DocTag';
import ApiLog from './apiLog/ApiLog';
import ApiLogRow from './apiLog/ApiLogRow';

const cmnViewMap = {
    'vCMNCompHeader': DocCompHeader,
    "vDocAttachment":DocAttachment,
    "vDocAttachmentEditor":DocAttachmentEditor,
    "vDocAttachmentRow":DocAttachmentRow,
    "vDocReferenceAttachmentRow":DocReferenceAttachmentRow,
    "vDocImage":DocImage,
    "vDocImageEditor":DocImageEditor,
    "vDocImageRow":DocImageRow,
    "vDocAttribute":DocAttribute,
    "vDocAttributeRow":DocAttributeRow,
    "vCMNApvWorkFlow":DocFormReview,
    "vCMNApvWorkFlowRow":DocReviewRow,
    "vChildCompActivator":DocChildActivator,
    "vReferenceBreakup":ReferenceBreakup,
    "vReferenceBreakupRow":ReferenceBreakupRow,

    "vTaskLog":DocLog,
    "vTaskLogEditor":DocLogEditor,
    "vTaskLogRow":DocLogRow,

    "vApiLog":ApiLog,
    "vApiLogRow":ApiLogRow,

    "vDocShare":DocShare,
    "vCMNDocTag":DocTag,
}

export default cmnViewMap;
